import { render, staticRenderFns } from "./settlementListAffTab.vue?vue&type=template&id=5f9445f3&scoped=true&lang=pug"
import script from "./settlementListAffTab.vue?vue&type=script&lang=js"
export * from "./settlementListAffTab.vue?vue&type=script&lang=js"
import style0 from "./settlementListAffTab.vue?vue&type=style&index=0&id=5f9445f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9445f3",
  null
  
)

export default component.exports